import Header from './Header';
import Footer from './Footer';

export default function SuccessSkeleton() {
  return (
    <div className="min-h-screen flex flex-col bg-bg">
      <Header />
      <main className="flex-1 flex items-center justify-center px-5 py-16">
        <div className="mx-auto w-full max-w-md text-center animate-pulse">
          <div className="mb-[24px] flex justify-center">
            <div className="h-16 w-16 rounded-full bg-gray-200" />
          </div>
          <div className="h-9 w-3/4 mx-auto rounded-lg bg-gray-200 mb-3" />
          <div className="h-4 w-full rounded bg-gray-200 mb-1" />
          <div className="h-4 w-2/3 mx-auto rounded bg-gray-200 mb-1" />
          <div className="h-4 w-1/2 mx-auto rounded bg-gray-200 mb-8" />
          <div className="rounded-[18px] border border-gray-200 mb-[6px] py-[16px] px-[25px] bg-gray-100">
            <div className="h-4 w-1/3 rounded bg-gray-200 mb-[6px]" />
            <div className="h-3 w-full rounded bg-gray-200 mb-1" />
            <div className="h-3 w-5/6 rounded bg-gray-200" />
          </div>
          <div className="mb-6 rounded-xl border border-border bg-surface p-5 text-left">
            <div className="h-4 w-1/3 rounded bg-gray-200 mb-4" />
            <div className="space-y-3">
              {[1, 2, 3].map(i => (
                <div key={i} className="flex items-center gap-[12px]">
                  <div className="h-5 w-5 shrink-0 rounded-full bg-gray-200" />
                  <div className="h-3 flex-1 rounded bg-gray-200" />
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
            <div className="h-[46px] w-full sm:w-36 rounded-lg bg-gray-200" />
            <div className="h-[46px] w-full sm:w-44 rounded-lg bg-gray-200" />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
